import { Input, Select } from 'common/InputForm';
import { CustomModal } from 'components/modals/ModalBox';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useEffect, useState } from 'react';

const MedicineType = ({ show, close, data, onAdd = () => { } }) => {
    const [input, setInput] = useState({ type: '', quantity: '' });
    const [error, setError] = useState({});
    const [buttonLoader, setButtonLoader] = useButtonLoader('Add');

    const isLoose = input?.type === 'LOOSE';

    useEffect(() => {
        if (show) {
            setInput({ type: 'STRIP', quantity: '' });
            setError({});
        }
    }, [show]);

    const validation = () => {
        let status = true;
        let errorMessage = {};

        if (!input?.type) {
            errorMessage["type"] = "Please select medicine type";
            status = false;
        }
        if (isLoose && !input?.quantity) {
            errorMessage["quantity"] = "Please enter quantity";
            status = false;
        }
        setError(errorMessage);
        return status;
    };

    const handleSubmit = () => {
        if (validation()) {
            onAdd(data, input?.type, input?.quantity);
            handleClose();
        }
    };

    const handleClose = () => {
        close();
        setError({});
        setInput({ type: '', quantity: '' });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newValue = value.replace(/^\s+/, "");

        if (name === "quantity") {
            newValue = newValue.replace(/\D/g, "");
            if (newValue.length > 4) return;
            setInput({ ...input, [name]: newValue });
        } else if (name === "type") {
            setInput({ ...input, [name]: newValue, quantity: '' });
            setError({});
        }
    };

    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={handleClose}
        >
            <h3>Medicine Type</h3>

            <div className="form_field">
                <Select
                    label="Medicine Type"
                    name="type"
                    value={input?.type}
                    onChange={handleChange}
                    error={error.type}
                >
                    <option value="" hidden>Select Medicine Type</option>
                    <option value="STRIP">Strip</option>
                    {!data?.billOnlyInStrip && <option value="LOOSE">Loose</option>}
                </Select>
            </div>

            {isLoose && (
                <div className="form_field">
                    <Input
                        className={"form-control input"}
                        label="Quantity"
                        type="text"
                        name="quantity"
                        value={input.quantity || ""}
                        onChange={handleChange}
                        placeholder="Enter quantity"
                        error={error?.quantity}
                        maxLength={4}
                    />
                </div>
            )}

            <div className="button_wrap">
                <button type="button" className="button light" onClick={handleClose}>
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={handleSubmit}
                    className="button"
                >
                    Add
                </button>
            </div>
        </CustomModal>
    );
};

export default MedicineType;